import { createReducer, on } from '@ngrx/store';
import * as ProfileActions from '../actions/profile.actions';
import { ProfileState, initialProfileState } from '../state/profile.state';

export const profileReducer = createReducer(
  initialProfileState,
  on(ProfileActions.setProfileData, (state, { data }) => ({ ...state, data }))
);
